// Allow /custom-task (no system id) to forward to the same form.
// We delegate to the [systemId] route with an empty systemId — the form
// component already supports a null/missing system (property-wide task).
import { useEffect } from 'react';
import { useRouter } from 'expo-router';
import { View } from 'react-native';

export default function CustomTaskRedirect() {
  const router = useRouter();
  useEffect(() => {
    // Use "none" as a sentinel for "no specific system" — the form handles it.
    router.replace('/custom-task/none' as never);
  }, [router]);
  return <View style={{ flex: 1 }} />;
}
